<script setup>
import { defineProps } from "vue"
import { Gems } from "@/gems"
import RatingScale from "./RatingScale.vue"
import { useValidationListView } from '@/composables/useValidationListView'
import BaseSelect from "./BaseSelect.vue";

const props = defineProps({
  validateData: {
    type: Object,
    default: Object
  },

  validationList: {
    type: Object,
    default: Object
  },
  
  ratingSkillsModal: {
    type: Object,
    default: Object
  },

  ratingData: {
    type: Object,
    default: Object
  },
})

const { ratingType } = useValidationListView({
  validateData: props.validateData,
  ratingSkillsModal: props.ratingSkillsModal,
})



</script>

<template>
  <div>    
    <div class="list-item list-header">
      <span>Data pedido</span>
      <span class="span-elem">Descrição</span>
      <span>Classificação</span>
      <span>Validador atual</span>
      <span>Validador novo</span>
      <span></span>
      <span></span>
    </div>

    <div class="div-row-frame" v-for="(elem, i) in props.validationList" :key="elem.id">
      <div class="list-item" :class="{'bg-alt-line': i % 2 == 0, 'div-to-validate': elem.validation_date == null && ratingType == 3}">            
        <span class="d-flex justify-content-center">
          <div class="div-request-date">{{ elem.request_date }}</div>
        </span>

        <span class="span-elem line-clamp line-clamp-1">
          <i v-if="!elem.is_op_skill" class="fa-solid fa-copyright me-1" @mouseover="Gems.Tooltip($event.target, 'Conhecimento', 'tooltip')"></i>
          <span @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
            {{ elem.designation }}
          </span>
        </span>
        
        <span class="radios">
          <RatingScale :rating-data="props.ratingData" :element="elem" :mobile-view="false" :validate-skills="true"/>
        </span>

        <span class="line-clamp line-clamp-1" @mouseenter="Gems.TooltipIfNeeded($event.target)">
          <base-select class="ddl-alt-padding" v-model="elem.history_id" v-if="elem.validators_to_transfer?.length > 1">
            <option value="">Escolha um validador...</option>
            <option v-for="(validator, vi) in elem.validators_to_transfer || []" :value="validator.history_id" :key="vi">
              {{ validator.validator_name }}
            </option>
          </base-select>

          <div v-else>
            {{ elem.validator_name }}
          </div>
        </span>

        <span class="line-clamp line-clamp-1">
          <base-select class="ddl-alt-padding" v-model="elem.newValidatorId">
            <option value="">Escolha um validador...</option>
            <option v-for="(validator, vi) in elem.available_validators || []" :value="validator.validator_id" :key="vi">
              {{ validator.validator_name }}
            </option>
          </base-select>
        </span>

        <span></span>

        <div class="modal-icon">
          <i class="fas fa-eye cursor-pointer" :class="{'eye-notification': elem.has_files_not_viewed }" @click="props.ratingSkillsModal.OpenModalDocs(elem)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')"></i>
          <i class="fas fa-envelope" v-if="elem.has_unread_messages_only_validators || elem.has_unread_messages" @mouseenter="Gems.Tooltip($event.target, 'Tens novas mensagens', 'tooltip')"></i>
        </div>
        
        <div class="div-btn">
          <button class="ddl-alt-padding" v-if="props.validateData.canChangeValidator(elem)" @click="props.validateData.ChangeValidator(elem)">TRANSFERIR</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './assets/styles/validate-skills.css';

.modal-icon {
  font-size: 1.1em;
}

.fa-envelope { 
  position: relative;
  left: 0px;
  top: -9px;
  font-size: 0.7em !important;
  width: 0px;
}

.icon-size {
  font-size: 12pt !important;
  position: unset;
  width: auto;
}


.list-item select {
  width: 100%;
  font-size: .9em;
  background-color: transparent;
  text-align: center;
}

.div-btn button {
  width: 100% !important;
}

.list-item {
  border-left: 4px solid transparent;
  grid-template-columns: 10% 20% 20% 10% 10% 10% 9% 9%;
}

.list-item {
  display: grid;
  text-align: center;
  align-items: center;
  gap: .2%;
  padding: 5px;
  margin-bottom: 1px;
  min-height: 40px;
}

.list-header {
  font-weight: bold;
}

.span-elem {
  text-align: left;
  cursor: default;
}

.div-radios div {
  gap: 10px; 
}

.div-radios div input {
  transform: scale(1.3);
}

.div-user-sitemap {
  display: flex;
  gap: 5px;
  padding: 10px 0px;
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.div-row-frame {
  border: 2px solid transparent;
}

.div-request-date {
  flex: 2;
}
 
@media screen and (max-width: 700px) {
  .list-item {
    font-size: .85em;
  }
}

@media screen and (max-width: 1200px) {
  .list-item {
    grid-template-columns: 12% 13% 21% 12% 12% 12% 3% 13%;
  }

  .div-btn button {
    width: unset !important;
  }

  .radios {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 3px;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios div {
    padding: 1px;
  }
}
</style>